var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 607.561,
    height: 396.489,
    viewBox: "0 0 607.561 396.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-817.306 -149.761)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1014.838 258.338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.202 107.947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.921,330.345c2.457-1.277,5-2.554,7.169-3.584,10.094-4.807,24.143-11.275,33.165-15.409,1.605-.728,3.2-1.414,4.628-1.991l.014-.014c1.126-.453,2.156-.851,3.021-1.181h.014c1.689-.645,2.774-1.016,2.774-1.016s.549-.055,1.511-.137c.233-.027.481-.055.755-.082,5.712-.536,20.833-1.964,29.842-2.664,3.557-.261,6.166-.426,6.867-.385a8.747,8.747,0,0,1,1.538.385c.508.151,1.126.343,1.84.591.755.247,1.607.549,2.554.893.124.041.275.1.439.165,1.483.522,3.143,1.154,4.958,1.84,1.4.536,2.953,1.126,4.6,1.772a6.923,6.923,0,0,1,.673.261h.014c.192.069.371.137.563.22a4.388,4.388,0,0,1,.481.192q1.71.68,3.708,1.442c12.772,5.04,28.276,11.467,31.311,13.664,5.754,4.12,26.34,105.044,26.889,111.9.536,6.661-28,15.766-54.424,22.742,0,3.873.027,8.35.082,13.129.041,3.461.1,7.086.137,10.767H274.088c.233-3.351.467-6.99.645-10.767.247-5.315.371-10.932.206-16.493,0,0,.275-16.3-1.346-23.319-.1-15.56-.6-31.05-1.085-42.6-.494-11.453-.961-19.048-.961-19.048q-1.566-21.053-2.17-39.414C270.5,331.6,271.7,330.963,272.921,330.345ZM418.175,430.954c-.192-13.129-17.688-37.574-17.688-37.574s-.755-.316-.825-.316c-.012.014-.891-.124-.891-.11-.027,0-2.719-2.568-2.747-2.568-.632,2.335-6.427,35.335-7.855,54.561C404.607,441.707,418.271,437.23,418.175,430.954Z",
    transform: "translate(-269.378 -303.875)",
    fill: "#f2f3f3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.35 113.419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.721,391.1c-.481-12.264-.715-20.5-.715-20.5-1.057-14.3-1.66-27.658-2.072-40.114a.487.487,0,0,1,.124-.055c.22-.11.673-.316,1.332-.632a.071.071,0,0,0,.055-.027c7.9-3.722,44.207-20.819,47.86-21.9l-.014.014c-.261.618-8.679,20.847-15.012,65.2-2.471,17.3-7.057,46.445-10.395,76.177-.33,3.021-.728,6.043-1.167,9.064-.632,4.45-1.36,8.885-2.115,13.266-.11.563-.206,1.126-.3,1.689-.22,1.25-.441,2.513-.673,3.749.014,0,.014,0,0,.014-.316,1.785-.645,3.557-.975,5.315H362.625c.11-.852.22-1.7.316-2.541,0-.027.014-.055.014-.082.206-1.785.424-3.543.632-5.3a2.059,2.059,0,0,1,.027-.275c.1-.865.192-1.717.288-2.568.714-6.455,1.3-12.634,1.758-18.361a65.7,65.7,0,0,0-.645-14.557C363.984,421.611,363.215,404.088,362.721,391.1Z",
    transform: "translate(-359.933 -307.86)",
    fill: "#3d475b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.604 109.821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.952,452.994a.048.048,0,0,0,.027-.014,33.3,33.3,0,0,1,4.518-1.648c0-.014,0-.014.014,0,2.541-.8,5.878-1.717,9.75-2.76,5.164-1.373,11.3-2.966,17.824-4.71-.012-.137-.027-.261-.04-.4-1.772-16.617-3.337-33.138-2.568-42.229,6.235-73.65,23.909-93.138,26.464-95.994.124.041.275.1.439.165,1.964.755,6.688,2.527,9.558,3.612.233.1.452.179.673.261h.014c.206.082.4.165.563.22s.343.137.481.192q1.71.68,3.708,1.442c12.813,4.9,33.316,12.277,36.31,14.434,5.754,4.12,28.441,109.933,29.128,116.772.453,4.628-29.142,14.3-59.354,22.921.069,2.225.26,4.683.563,7.306.383,3.323.92,6.949,1.607,10.767h-43.19c-.275-2.2-.536-4.45-.8-6.729-10,2.582-17.455,4.436-20.133,5.1-.7.178-1.085.275-1.085.275l-.645-1.1-.3-.522-.165-.288c-.179-.288-.371-.632-.577-.989l-.673-1.154-.494-.852-.755-1.3-.316-.563c-.386-.659-.783-1.346-1.181-2.06l-.33-.577c-3.42-6.029-7.553-13.555-9.572-18.086-.1-.233-.192-.453-.29-.673S264.32,453.324,264.952,452.994Zm86.917-60.082c-1.483,5.177-3.557,19.927-5.371,34.607,6.113-3.076,10-6.207,10.068-9.242C356.964,403.2,351.869,392.912,351.869,392.912Z",
    transform: "translate(-264.109 -305.24)",
    fill: "#3d475b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(144.841 74.583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.5,314.1s-4.584-8.663-3.318-33.257C363.533,274.03,327.39,297,327.39,297s.125,2.348.2,5.518c.041,1.32.065,2.764.065,4.25,0,.411-.005.82-.005,1.23-.005.672-.011,1.338-.023,2-.018.827-.048,1.634-.089,2.414-.041.886-.1,1.723-.184,2.491a22.75,22.75,0,0,1-1.338,4.827C324.359,323.561,352.968,323.779,366.5,314.1Z",
    transform: "translate(-325.949 -279.581)",
    fill: "#f4c3a4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M351.634,316.108l-6.66,8.95s3.9,5.225,10.833,1.368Z",
    transform: "translate(-196.543 -191.362)",
    fill: "#4f88f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.481,322.954s-24.4,59.6-19.2,135.308l7.7,13.969,8.679-11.9s1.4-100.545,8.326-137.618Z",
    transform: "translate(-217.268 -188.895)",
    fill: "#4f88f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.007,310.726l7.132,8.343s11.445-2.217,14.806-8.2S337.007,310.726,337.007,310.726Z",
    transform: "translate(-189.047 -194.323)",
    fill: "#f4c3a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,304.716s.828,6.36,8.767,15.645L352.7,332l-4.69-24.152Z",
    transform: "translate(-206.276 -195.615)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.982,299.146s-16.548,18.72-28.121,23.294l5.382,13.313,26.411-29.136Z",
    transform: "translate(-169.769 -197.694)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 133.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.375,459.881s21.966-21.3,36.375-24.849c6.659-1.638,15.432-10.833,23.769-21.641,2.748-3.56,5.442-7.3,8.006-10.993a.026.026,0,0,0,.008-.016c10.227-14.766,18.242-28.921,18.242-28.921s30.231-35.429,5.973-51.222c0,0-10.4-.224-16.1,2.872-5.864,3.185-18.372,29.289-20.492,33.912s-25.094,47.552-26.633,48.518-4.1,4.495-13.294,9.444c-11.254,6.059-28.934,23.794-28.934,23.794Z",
    transform: "translate(-377.294 -322.236)",
    fill: "#3d475b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.242,429.034a6.124,6.124,0,0,0,1.236,3.145,4.647,4.647,0,0,0,1.62,1.332,17.24,17.24,0,0,0,1.346,4.106c.014,0,.014,0,0,.014a7.833,7.833,0,0,0,1.744,2.376,9.167,9.167,0,0,0,1.085,2.939h23.882c1.772-1.387,5.658-4.9,8.556-7.567,1.674-1.538,3.035-2.8,3.461-3.2a1.615,1.615,0,0,1,.151-.137l-2.17-3.323-3.914-6.029-2.815-9.27s-2.6.261-6.111.673c-.3.027-.6.069-.92.1-.481.069-.989.124-1.5.178-6.5.8-14.639,1.964-16.356,2.98a8.058,8.058,0,0,0-.8.536,10.1,10.1,0,0,0-1.209,1.03c-1.524,1.5-2.376,3.131-3.282,3.983C356.854,423.28,353.022,427.373,353.242,429.034Z",
    transform: "translate(-248.401 -155.035)",
    fill: "#f4c3a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.377,234.493s-39.683-9.566-31.324,40.676,17.876,54.321,42.051,44.3S389.6,277.319,391.038,261.6,369.072,235.226,356.377,234.493Z",
    transform: "translate(-202.893 -222.101)",
    fill: "#f4c3a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18,260.659c.589-4.412,9.351-5.905,9.956.733S332.9,279.6,329.6,278.4,326.367,266.744,327.18,260.659Z",
    transform: "translate(-152.845 -213.473)",
    fill: "#f4c3a4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.612,290.449s-.8-15.8-6.556-16.381-6.739,5.768-6.739,5.768l-5.839,1.013s2.042-13.81-3.679-16.312-37.418,7.07-41.981,2.94-1.976-32.167,6.439-35.884,31.627-11.988,48.373-.291c0,0,13.206-1.31,15.006,9.359S392.312,282.59,388.612,290.449Z",
    transform: "translate(-202.783 -225.272)",
    fill: "#16202e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.249,417.07l16.385,28.169s43.406-11.183,53.534-14.039l-23.151-27.557S326.882,411.441,314.249,417.07Z",
    transform: "translate(-182.71 -158.684)",
    fill: "#3d475b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.807,308.537h.005c21.283-2.171,29.536-18.556,29.536-18.556a43.93,43.93,0,0,1-29.448,12.88c0,.411.019.847.019,1.258-.006.672-.011,1.338-.023,2C332.878,306.95,332.848,307.757,332.807,308.537Z",
    transform: "translate(-186.375 -201.115)",
    fill: "#ce9572"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(901.715 385.008)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.117 21.113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.542,357.732a2.152,2.152,0,0,0,1.522-3.672l-20.542-20.546a2.151,2.151,0,0,0-3.042,3.042L531.022,357.1A2.136,2.136,0,0,0,532.542,357.732Z",
    transform: "translate(-509.85 -332.883)",
    fill: "#3d475b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.351,350.864a2.15,2.15,0,0,0,2.151-2.151V319.661a2.151,2.151,0,1,0-4.3,0v29.052A2.152,2.152,0,0,0,501.351,350.864Z",
    transform: "translate(-499.199 -317.509)",
    fill: "#3d475b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 56.286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.179,362.8h29.055a2.151,2.151,0,1,0,0-4.3H521.179a2.151,2.151,0,1,0,0,4.3Z",
    transform: "translate(-519.027 -358.495)",
    fill: "#3d475b"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.86 55.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.557,429.872H353.8c-4.958,0-6.486-4.017-6.486-8.977H540.537A8.978,8.978,0,0,1,531.557,429.872Z",
    transform: "translate(-322.218 -333.917)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.08,420.895H343.07c0,4.96,4.565,8.977,10.2,8.977h41.294c.056,0,11.731,0,11.787,0C412.157,429.789,411.889,420.895,406.08,420.895Z",
    transform: "translate(-186.432 -333.917)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.047,447.15H414.432a7.89,7.89,0,0,1-7.75-6.419l-17.2-73.807a7.89,7.89,0,0,1,7.752-9.365h127.61a7.892,7.892,0,0,1,7.755,6.42l17.2,73.8A7.893,7.893,0,0,1,542.047,447.15Z",
    transform: "translate(-389.34 -357.56)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.779,363.576a7.873,7.873,0,0,0-3.148-4.932,7.86,7.86,0,0,0-3.148,7.876l17.2,73.807a7.874,7.874,0,0,0,3.144,4.926,7.872,7.872,0,0,0,3.153-7.873Z",
    transform: "translate(-252.519 -357.155)",
    fill: "#3d475b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.283,401.261h20.928a7.775,7.775,0,0,0,7.774-7.774h0a7.774,7.774,0,0,0-7.774-7.773H447.283a7.774,7.774,0,0,0-7.774,7.773h0A7.775,7.775,0,0,0,447.283,401.261Z",
    transform: "translate(-384.284 -347.05)",
    fill: "#3d475b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.607 84.968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.233,423.916h6.279a2.243,2.243,0,0,0,2.243-2.243h0a2.243,2.243,0,0,0-2.243-2.243h-6.279a2.242,2.242,0,0,0-2.243,2.243h0A2.242,2.242,0,0,0,356.233,423.916Z",
    transform: "translate(-317.216 -419.431)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.159,423.916h6.279a2.242,2.242,0,0,0,2.243-2.243h0a2.242,2.242,0,0,0-2.243-2.243h-6.279a2.242,2.242,0,0,0-2.243,2.243h0A2.242,2.242,0,0,0,365.159,423.916Z",
    transform: "translate(-338.4 -419.431)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.085,423.916h6.279a2.242,2.242,0,0,0,2.243-2.243h0a2.242,2.242,0,0,0-2.243-2.243h-6.279a2.242,2.242,0,0,0-2.243,2.243h0A2.242,2.242,0,0,0,374.085,423.916Z",
    transform: "translate(-359.584 -419.431)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.011,423.916h6.279a2.242,2.242,0,0,0,2.243-2.243h0a2.242,2.242,0,0,0-2.243-2.243h-6.279a2.242,2.242,0,0,0-2.243,2.243h0A2.242,2.242,0,0,0,383.011,423.916Z",
    transform: "translate(-380.768 -419.431)",
    fill: "#212839"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M162.374,432.463a5.367,5.367,0,0,0,1.579,3.8,5.308,5.308,0,0,0,3.79,1.579H704.72a5.383,5.383,0,0,0,0-10.767H167.744A5.372,5.372,0,0,0,162.374,432.463Z",
    transform: "translate(714.779 108.403)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1311.78 444.425)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.884,413.761a.567.567,0,0,0,.562-.492c.038-.3,4.009-29.588,10.951-36.67a.567.567,0,1,0-.81-.794c-7.206,7.349-11.1,36.093-11.267,37.314a.569.569,0,0,0,.488.639Z",
    transform: "translate(-189.547 -355.227)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.281,364.082c-1.912,6.328-1.52,12.044.873,12.768s5.883-3.821,7.795-10.149c.019-.063.038-.126.056-.19,1.619-5.637-6.893-8.21-8.666-2.617C212.32,363.956,212.3,364.019,212.281,364.082Z",
    transform: "translate(-197.618 -360.774)",
    fill: "#3d475b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.794,375.908c6.328,1.912,12.044,1.52,12.768-.873s-3.821-5.883-10.149-7.795l-.19-.056c-5.637-1.62-8.21,6.893-2.619,8.666Z",
    transform: "translate(-216.486 -366.979)",
    fill: "#3d475b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.982,380.929c-6.327-1.912-10.871-5.4-10.147-7.795s6.439-2.785,12.766-.873l.189.059c5.591,1.773,3.02,10.285-2.618,8.666Z",
    transform: "translate(-191.026 -365.461)",
    fill: "#3d475b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.574 17.372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.376,386.963c-1.778-6.367-1.269-12.073,1.14-12.746s5.8,3.941,7.581,10.308c.018.065.036.128.052.191,1.5,5.67-7.063,8.064-8.718,2.436C212.411,387.09,212.394,387.027,212.376,386.963Z",
    transform: "translate(-198.645 -373.152)",
    fill: "#3d475b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.109,385.39c5.006-4.316,7.741-9.351,6.108-11.245s-7.015.07-12.022,4.386l-.148.13c-4.39,3.891,1.417,10.625,5.911,6.856C225.009,385.476,225.059,385.432,225.109,385.39Z",
    transform: "translate(-217.487 -373.424)",
    fill: "#3d475b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.828,373.682a3.1,3.1,0,1,0,3.859-2.068A3.1,3.1,0,0,0,214.828,373.682Z",
    transform: "translate(-202.276 -356.777)",
    fill: "#212839"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 27.985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.349,390.745c-8.221,6.477-12.9,14.248-10.449,17.359s11.1.38,19.322-6.1,10.45-17.359,10.45-17.359S221.571,384.268,213.349,390.745Z",
    transform: "translate(-174.345 -379.849)",
    fill: "#3d475b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.265,401.852c8.678,8.151,18.211,12.1,21.294,8.813s-1.453-12.549-10.131-20.7-21.294-8.812-21.294-8.812S222.587,393.7,231.265,401.852Z",
    transform: "translate(-221.134 -381.152)",
    fill: "#3d475b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.039 53.006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.373,438.094h28.394l4.97-35.721H208.4Z",
    transform: "translate(-204.901 -398.251)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.339,
    height: 13.281,
    rx: 1.469,
    fill: "#212839"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(817.306 130.761)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(161.856 19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.891,128.051H503.83a26.043,26.043,0,0,0-26.042,26.043V213.44a26.042,26.042,0,0,0,26.042,26.042h75.241l27.062,23.879V239.483h12.758a26.042,26.042,0,0,0,26.043-26.042V154.094A26.043,26.043,0,0,0,618.891,128.051Z",
    transform: "translate(-477.788 -128.051)",
    fill: "#3d475b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.517 30.199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.412,156.571H509.828a3.265,3.265,0,0,1,0-6.53h81.584a3.265,3.265,0,0,1,0,6.53Z",
    transform: "translate(-506.564 -150.041)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 21.756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591.412,172.412H509.828a3.264,3.264,0,1,1,0-6.529h81.584a3.264,3.264,0,0,1,0,6.529Z",
    transform: "translate(-506.564 -165.883)",
    fill: "#212839"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 43.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572.487,188.254H560.522a3.265,3.265,0,0,1,0-6.53h11.964a3.265,3.265,0,0,1,0,6.53Z",
    transform: "translate(-557.258 -181.724)",
    fill: "#212839"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.196 43.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.685,188.254H540.719a3.265,3.265,0,0,1,0-6.53h11.966a3.265,3.265,0,0,1,0,6.53Z",
    transform: "translate(-537.456 -181.724)",
    fill: "#212839"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.39 43.51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M537.023,188.254h-27.2a3.265,3.265,0,0,1,0-6.53h27.2a3.265,3.265,0,0,1,0,6.53Z",
    transform: "translate(-506.564 -181.724)",
    fill: "#212839"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 148.198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.642,214.35h88.076A15.684,15.684,0,0,1,527.4,230.033v50.789a15.673,15.673,0,0,1-14.536,15.626l18.162,29.761-47.864-29.7H423.642a15.684,15.684,0,0,1-15.683-15.685V230.033A15.683,15.683,0,0,1,423.642,214.35Z",
    transform: "translate(-407.959 -214.35)",
    fill: "#212839"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.178 14.007)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.797 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.428,
    cy: 10.428,
    r: 10.428,
    transform: "translate(14.747 29.494) rotate(-135)",
    fill: "#3d475b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.436,250.961a12.323,12.323,0,1,0-12.323-12.323A12.336,12.336,0,0,0,457.436,250.961Zm0-20.855a8.532,8.532,0,1,1-8.531,8.532A8.541,8.541,0,0,1,457.436,230.106Z",
    transform: "translate(-442.689 -223.891)",
    fill: "#3d475b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 32.126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.14,265.123h49.293a15.8,15.8,0,0,0-15.8-15.8h-17.7a15.8,15.8,0,0,0-15.8,15.8Z",
    transform: "translate(-434.243 -247.427)",
    fill: "#3d475b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.655,267.535h49.295a1.9,1.9,0,0,0,1.9-1.9,17.717,17.717,0,0,0-17.7-17.7H452.454a17.717,17.717,0,0,0-17.7,17.7A1.9,1.9,0,0,0,436.655,267.535Zm47.269-3.793H438.68a13.925,13.925,0,0,1,13.774-12.007h17.695A13.925,13.925,0,0,1,483.924,263.742Z",
    transform: "translate(-434.758 -247.943)",
    fill: "#3d475b"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.fc4c77b38a4f78019a4642789890517b.svg";
export { ForwardRef as ReactComponent };